import { render, staticRenderFns } from "./SidBarAiChat.vue?vue&type=template&id=d4761c6e"
import script from "./SidBarAiChat.vue?vue&type=script&lang=js"
export * from "./SidBarAiChat.vue?vue&type=script&lang=js"
import style0 from "./SidBarAiChat.vue?vue&type=style&index=0&id=d4761c6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports